var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18.75,
    viewBox: "0 0 15 18.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Alert",
    d: "M17.125,15.481V10.673c0-2.952-1.537-5.423-4.219-6.077V3.942a1.407,1.407,0,1,0-2.812,0V4.6C7.4,5.25,5.875,7.712,5.875,10.673v4.808L4,17.4v.962H19V17.4ZM11.5,21.25a1.905,1.905,0,0,0,1.875-1.923H9.625A1.9,1.9,0,0,0,11.5,21.25Z",
    transform: "translate(-4 -2.5)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.facfe4db4be57c85892382b2193380f2.svg";
export { ForwardRef as ReactComponent };